import { useState } from 'react';
import CreateCharterRideForm from 'components/forms/RideFormFactory/CreateCharterRideForm';
import { useTranslation } from 'react-i18next';
import { ModalBase } from 'remote/global';
import ViewPermissionsGate from '@/utils/view-permissions-gate';
import { useUsersCurrentAccessesQuery } from '@/api/queries/users';

interface Props {
  open: boolean;
  onClose: () => void;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onSubmit: () => void;
}

function CreateCharterRideModal({ open, setOpen, onClose, onSubmit }: Props) {
  const { t } = useTranslation();
  const [activeStep, setActiveStep] = useState(0);
  const { data: userInfo } = useUsersCurrentAccessesQuery();
  const { permissions = {} } = userInfo || {};

  return (
    <ModalBase
      open={open}
      setOpen={setOpen}
      onClose={onClose}
      maxWidth='xl'
      fullWidth
      title={t('CorporateCharterView.title').toString()}
      preventCloseOutside
    >
      <ViewPermissionsGate role={permissions.CORPORATE_CHARTER}>
        <CreateCharterRideForm
          onSubmit={onSubmit}
          setActiveStep={setActiveStep}
          activeStep={activeStep}
        />
      </ViewPermissionsGate>
    </ModalBase>
  );
}

export default CreateCharterRideModal;
